<!--
Separated out date/time criteria for the Booking Search screen
@author cm359n
-->
<template>
  <table class="criteria" >
    <tr>
        <td><label class="no-border" for="bookingDate">Date</label></td>
        <td><label class="no-border" for="startTime">Time from</label></td>
        <td><label class="no-border" for="endTime">Time to</label></td></tr>

    <tr><td class="no-border-td">
        <select
          :key="constraintKey"
          @change="onDayChange"
          class="newSelect"
          v-model="currDay" id="bookingDate">
            <option v-for="(i, index) in daysMenu"
              :disabled="isDayDisabled(index)"
              :key="i.value" :value="i.value">{{ i.display }}</option>
        </select></td><td class="no-border-td">
        <select class="newSelect"
          @change="onStartTimeChange"
          v-model="currTimeFrom" id="startTime">
            <option v-for="i in range(bookingStartHour, bookingEndHour)"
              :key="i.value" :value="i.value">{{ i.display }}</option>
        </select>
    </td><td class="no-border-td">
        <select class="newSelect"
          @change="onEndTimeChange"
          v-model="currTimeTo" id="endTime">
            <option v-for="i in range(bookingStartHour, bookingEndHour)"
              :key="i.value" :value="i.value">{{ i.display }}</option>
        </select>
    </td></tr>
  </table>

</template>
<script setup>
import { useStringUtil } from '@/composables/StringMethods.js'
import { ref, defineProps, defineEmits, onMounted, watch } from 'vue'

const { advanceRange, range } = useStringUtil()

const props = defineProps({
  fakeTime: String,
  advanceDays: Number,
  bookingStartHour: Number,
  bookingEndHour: Number,
  dayTS: Number,
  timeFrom: String,
  timeTo: String,
  disabledDayItems: Array,
  constraint: Object
})

const constraintKey = ref('x')
const currDay = ref(props.dayTS)
const currTimeFrom = ref(props.timeFrom)
const currTimeTo = ref(props.timeTo)
const currDisabled = ref(props.disabledDayItems)

const daysMenu = ref(advanceRange(false, props.advanceDays))
const timesMenu = ref(range(props.bookingStartHour, props.bookingEndHour))

const emit = defineEmits([
  'change-day',
  'change-start-time',
  'change-end-time',
  'clear-room-message',
  'updated-for-constraint'
])

watch(() => props.constraint,
  (c) => {
    let ctr = 0
    let ckRet = 'x'
    let noweekends = isFalse(c.availableWeekend)

    for (var i of daysMenu.value) {
      let setDisabled = false
      if (noweekends && (i.display.startsWith('Sat') || i.display.startsWith('Sun'))) {
        setDisabled = true
      }
      if (typeof c.minDate !== 'undefined' && i.value < c.minDate) {
        setDisabled = true
      }
      if (typeof c.maxDate !== 'undefined' && i.value > c.maxDate) {
        setDisabled = true
      }
      // console.log('menu day ' + ctr + ' disabled? ' + setDisabled)
      currDisabled.value[ctr] = setDisabled
      ctr++
    }
    ckRet = (c.availableWeekend) ? 'true' : 'false'
    ckRet += '' + c.maxDate + c.minDate
    constraintKey.value = ckRet
    // FIXME forceUpdate doesn't work in Vue 3
    emit('updated-for-constraint') // sorry. the day dropdown doesn't seem to pick up this.currDisabled changes :-(
  })

onMounted(() => {
  setSlot()
})

// FIXME hacky exposed function to update the drop-down menu 
// when parent component SearchDetails' axios call returns with the correct date range...
function updateMe(temporalCriteria) {
  console.log('updating temporal criteria as requested')
  let dm = temporalCriteria.daysInAdvance
  console.log('update num of days in advance = ' + dm)
  daysMenu.value = advanceRange(false, temporalCriteria.daysInAdvance)
}
function isFalse (b) { // false and not null/undef
  if (typeof b !== 'undefined' && b === false) {
    return true
  } else {
    return false
  }
}

function isDayDisabled (i) {
  if (typeof currDisabled.value !== 'undefined') {
    return currDisabled.value[i] == true
  }
  return false
}

function setSlot () {
  // initial day choice is today so we'll set initial time choice to be next half hour
  let d = new Date()
  if (typeof props.fakeTime !== 'undefined') {
    let pd = props.fakeTime.split(':')
    let hh = parseInt(pd[0])
    let mm = parseInt(pd[1])
    d.setHours(hh)
    d.setMinutes(mm)
    console.log('testing time ' + props.fakeTime)
  }
  let ddisp = hrMin(d)
  let lastOption = timesMenu.value.length - 1

  if (ddisp > timesMenu.value[lastOption - 1].value) {
    console.log('last time slot passed for today')
    currDay.value = daysMenu.value[1].value
    emit('change-day', currDay.value)
  } else {
    let earliest = 0
    for (let i = timesMenu.value.length - 1; i >= 0; i--) {
      // find earliest slot after the current time - 30 mins
      // console.log(typeof ddisp)
      if (timesMenu.value[i].value >= ddisp) {
        earliest = i
      }
    }

    let endOption = earliest + 1 < lastOption ? earliest + 1 : lastOption
    console.log('earliest booking time for today is ' + timesMenu.value[earliest].value)

    currTimeFrom.value = timesMenu.value[earliest].value
    emit('change-start-time', currTimeFrom.value)
    currTimeTo.value = timesMenu.value[endOption].value
    emit('change-end-time', currTimeTo.value)
  }
}

function onDayChange () {
  emit('clear-room-message')
  emit('change-day', currDay.value)
}

function onStartTimeChange () {
  emit('clear-room-message')
  emit('change-start-time', currTimeFrom.value)
}

function onEndTimeChange () {
  emit('clear-room-message')
  emit('change-end-time', currTimeTo.value)
}

function hrMin (d) {
  let dhr = d.getHours() + ''
  let dmin = (d.getMinutes() - 30) + ''
  let ddisp = dhr.padStart(2, '0') + ':' + dmin.padStart(2, '0')
  return ddisp
}
defineExpose({
  updateMe
})
</script>
<style scoped>

.newSelect {
  border:0px;
  font-family:PTSans;
  color:#4F5961;
  font-size:16px;
  margin-left:-2px;
}
.newSelect option:disabled {
  background:lightgray;
}
label.no-border {
  font-weight:700;
  color: #003865;
}
select.custom-select.select-sd {
  box-sizing: border-box;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
}

select.custom-select > option:disabled {
  background: #eee;
  font-style: italic;
}
</style>
